import React from 'react'
import './Hero.css'
import { Link } from 'react-router-dom'
 

const Hero = ({ title, description, cta, theme, snowman }) => {
    const isExternalCta = Boolean(cta?.href?.startsWith('http'));
    const themeName = theme?.name || 'winter';
    const showSnow = theme?.effects?.snow ?? true;
    const showSnowman = theme?.effects?.snowman ?? true;
    return (
        <div className={`hero theme--${themeName}`} id='hero-navigate'>
            <div className='hero-text'>
                <h1 className='hero-h1'>{title}</h1>
                <div className='hero-para-div'>
                    {description?.map((paragraph, index) => (
                        <p className='hero-para' key={`${paragraph}-${index}`}>
                            {paragraph}
                        </p>
                    ))}
                </div>
                {isExternalCta ? (
                    <a href={cta?.href} className='hero-btn-link'>
                        <button className='hero-btn'>{cta?.label}</button>
                    </a>
                ) : (
                    <Link to={cta?.href || '/appointment'}>
                        <button className='hero-btn'>{cta?.label || 'Book Now'}</button>
                    </Link>
                )}
            </div>
            {showSnow ? (
                <>
                    {/* Holiday effects */}
                    <div className="snow-ground"></div>
                    <div className="snow-pile"></div>
                    <div className="snow-spots">
                        <div className="snow-spot"></div>
                        <div className="snow-spot"></div>
                        <div className="snow-spot"></div>
                        <div className="snow-spot"></div>
                        <div className="snow-spot"></div>
                        <div className="snow-spot"></div>
                    </div>
                </>
            ) : null}
            {showSnow && showSnowman ? (
                <div 
                    className="snowman-container"
                    onClick={() => window.location.href = snowman?.href || 'https://nail-labs.square.site/'}
                    role="button"
                    tabIndex={0}
                    aria-label={snowman?.ariaLabel || 'Click snowman for inspo!'}
                >
                    <div className="snowman">
                        <div className="head">
                            <div className="eye left"></div>
                            <div className="eye right"></div>
                            <div className="carrot"></div>
                        </div>
                        <div className="body">
                            <div className="button"></div>
                            <div className="button"></div>
                            <div className="button"></div>
                        </div>
                        <div className="base"></div>
                        <div className="arms left-arm"></div>
                        <div className="arms right-arm"></div>
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default Hero
